import "./footer.css";

export default function Footer({ logo, t }) {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* BRAND */}
        <div className="footer-brand">
          <img src={logo} alt="Matneu Investment" />

          <p>{t.footer}</p>
        </div>

        {/* LINKS */}
        <div className="footer-links">
          <h4>Navigation</h4>

          <a href="#services">Services</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h4>Contact</h4>

          <a href="mailto:info@matneuinvestment.com">
            info@matneuinvestment.com
          </a>

          <a href="https://wa.me/" target="_blank" rel="noreferrer">
            WhatsApp
          </a>

          <a href="#">Instagram</a>
        </div>
      </div>

      <div className="footer-bottom">
        © {year} Matneu Investment. All rights reserved.
      </div>
    </footer>
  );
}